import { render } from "./apiCharge.vue?vue&type=template&id=22d17fd0&scoped=true&ts=true"
import script from "./apiCharge.vue?vue&type=script&lang=ts"
export * from "./apiCharge.vue?vue&type=script&lang=ts"

import "./apiCharge.vue?vue&type=style&index=0&id=22d17fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d17fd0"]])

export default __exports__